import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Table, TableBody } from '@material-ui/core';
import _ from 'lodash';
import ApplicationTableHeader from './ApplicationTableHeader';
import ApplicationTableRow from './ApplicationTableRow';
import ValidationError from './ValidationError';

class MultiChoiceField extends React.Component {
  
  state = {
    selectedItems: this.props.input.value || [],
  }

  handleClick = applicationId => {
    const newItems = this.state.selectedItems.includes(applicationId)
      ? this.state.selectedItems.filter(a => a !== applicationId)
      : [...this.state.selectedItems, applicationId];

    if (this.props.categoriesChoiceLimits && this.props.categoriesChoiceLimits.length && !this.state.selectedItems.includes(applicationId)) {
      const project = this.props.values.find(a => a.id === applicationId);
      const categoryLimit = this.props.categoriesChoiceLimits.find(c => c.category === project.category);
      if (categoryLimit) {
        if (categoryLimit.limit) {
          if (this.props.values.filter(v => this.state.selectedItems.includes(v.id) && v.category === categoryLimit.category).length === categoryLimit.limit) {
            console.debug('Przekroczono limit projektów dla wybranej kategorii');
            return;
          }
        } else if (categoryLimit.subcategories) {
          const subcategoryLimit = categoryLimit.subcategories.find(c => c.category === project.subcategory);
          if (subcategoryLimit && subcategoryLimit.limit) {
            if (this.props.values.filter(v => this.state.selectedItems.includes(v.id) && v.category === categoryLimit.category && v.subcategory === subcategoryLimit.category).length === subcategoryLimit.limit) {
              console.debug('Przekroczono limit projektów dla wybranej podkategorii');
              return;
            }
          }
        }
      }
    }

    this.setState({ selectedItems: newItems });

    this.props.input.onChange(newItems);
    this.props.input.onBlur();
  }

  renderTable = (applications, categoriesEnabled, subcategoriesEnabled, selectedItems, limitAnswers) => (
    <Table className="projects-table">
      <ApplicationTableHeader categoriesEnabled={categoriesEnabled} subcategoriesEnabled={subcategoriesEnabled} leftAction />
      <TableBody>
        {applications.map(application => (
          <ApplicationTableRow
            key={application.id}
            application={application}
            leftAction={<Checkbox
              checked={selectedItems.includes(application.id)}
              onClick={() => this.handleClick(application.id)}
              value={application.id}
              color="primary"
              disabled={this.props.disabled || (limitAnswers <= 0 ? false : !selectedItems.includes(application.id) && selectedItems.length >= limitAnswers)}
            />}
            categoriesEnabled={categoriesEnabled}
            subcategoriesEnabled={subcategoriesEnabled}
          />)
        )}
      </TableBody>
    </Table>);
  
  render() {
    const { selectedItems } = this.state;
    const { meta: { error, touched }, values, groupByDistricts, districts, limitAnswers } = this.props;
    const categoriesEnabled = values.filter(a => a.category !== null).length > 0;
    const subcategoriesEnabled = values.filter(a => a.subcategory !== null).length > 0;

    return (
      <React.Fragment>
        <div className="box">
          <div className="col-sm-12">
            {groupByDistricts || categoriesEnabled
              ? _(values)
                .groupBy(x => groupByDistricts ? x.district : x.category)
                .map((value, key) => ({ key, applications: value}))
                .sortBy(x => groupByDistricts ? districts.indexOf(x.key) : ['key'])
                .value()
                .map(x => (
                  <div key={x.key} style={{ marginBottom: 30 }}>
                    <h3 className="category"><i className="fa fa-bookmark" /> <span>{groupByDistricts ? 'Obszar' : 'Kategoria'}</span> {x.key}</h3>
                    {this.renderTable(x.applications, groupByDistricts ? categoriesEnabled : false, subcategoriesEnabled, selectedItems, limitAnswers)}
                  </div>))
            : this.renderTable(values, categoriesEnabled, subcategoriesEnabled, selectedItems, limitAnswers)}
          </div>
      </div>
      {error && touched ? <ValidationError error={error} /> : null}
    </React.Fragment>);
  }
}

MultiChoiceField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  values: PropTypes.array.isRequired,
  categoriesChoiceLimits: PropTypes.array,
  groupByDistricts: PropTypes.bool.isRequired,
  districts: PropTypes.array,

};

export default MultiChoiceField;



// WEBPACK FOOTER //
// ./src/components/budget/types/MultiChoiceField.js